import { RootState } from 'data/root.reducers';
import { Contact, ContactState } from './contact.types';

// eslint-disable-next-line import/prefer-default-export
export const getContacts = (state: RootState): Contact[] => (state.contacts as ContactState).contacts;

export const getContact = (state: RootState): Contact | undefined => (state.contacts as ContactState)?.single?.[0];

export const getContactCreatedId = (state: RootState): string | null => (state.contacts as ContactState).createdId;

export const isContactCreatePopupOpen = (state: RootState): boolean => (state.contacts as ContactState).ui.isCreatePopupOpen;

export const isContactLoading = (state: RootState): boolean => (state.contacts as ContactState).ui.isLoading;

export const getSelectedContact = (state: RootState): Contact[] => (state.contacts as ContactState).selected;

export const getCreatingContact = (state: RootState): Contact | null => (state.contacts as ContactState)?.creatingContact;
